import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  column: {
    display: 'flex',
    flexDirection: 'column',
  },
  caption: {
    height: '10px',
    fontSize: '12px',
    color: grey[500],
    alignSelf: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'noWrap',
  },
})
const FilterItem = ({ classes, caption, hideCaption, children }) =>
  <div className={classes.column}>
    {!hideCaption &&
      <div className={classes.caption}>{caption}</div>
    }
    <div className={classes.row}>
      {children}
    </div>
  </div>

export default withStyles(styles)(FilterItem);



// WEBPACK FOOTER //
// ./src/components/core/Filter/FilterItem.jsx